var map = {
	"./carrie & lowell.png": 398,
	"./dreamland.png": 999,
	"./dusk.png": 150,
	"./happier than ever.png": 582,
	"./harry's house.png": 427,
	"./infinitely ordinary.png": 274,
	"./magic man.png": 728,
	"./now, not yet.png": 833,
	"./oddinary.png": 169,
	"./ok orchestra.png": 757,
	"./pebble brain.png": 800,
	"./sunset season.png": 901,
	"./test album.png": 955,
	"./wasteland, baby.png": 666,
	"./ycgma.png": 485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 573;